import { AmbientLight, Color, MathUtils, Scene, Vector3 } from "three";
// import { TooltipsMenu } from "../objects/TooltipsMenu";
import { CameraController } from "../../componets3D/CameraController";
import { MapOxxoMain } from "../objects/MapOxxoMain";

export class MainScene extends Scene {
	constructor(container, loadingManager) {
		super();
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.background = new Color(0x04337a);
		this.create(container);
		this.light();
		this.renderAnimations();

	}
	create(container, pointsTootltips) {
		// this.tooltipsMenu = new TooltipsMenu(container, pointsTootltips, this.camera, this);
		this.mapmenu = new MapOxxoMain(this.loadingManager);
		this.add(this.mapmenu);
	}

	SceneInitialState() {
		// this.mapmenu.createSceneChange();
		// this.mapmenu.onhiddenceling();
		this.camera.position.set(-0.7259, 128.3289, 170.6788)
		this.mapmenu.Backgroung.scale.set(0.5, 0.5, 0.5)

		this.camera.moveCameraToPoint(new Vector3(1.76, 19.225, 27.46), 1, new Vector3(0.34, -0.51, 0.09), () => {
			this.camera.enabledOrbitControls();
			this.camera.control.maxPolarAngle = MathUtils.degToRad(80);
			this.camera.control.minPolarAngle = MathUtils.degToRad(30);
			this.camera.control.enableRotate = true;
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.control.minDistance = 28;
			this.camera.control.maxDistance = 36;
			this.camera.control.enablePan = false;
		});
	}

	moveMain() {
		this.camera.moveCameraToPoint(new Vector3(1.76, 19.225, 27.46), 1, new Vector3(0.34, -0.51, 0.09), () => {
			this.camera.enabledOrbitControls();
			this.camera.control.maxPolarAngle = MathUtils.degToRad(80);
			this.camera.control.minPolarAngle = MathUtils.degToRad(30);
			this.camera.control.enableRotate = true;
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.control.minDistance = 28;
			this.camera.control.maxDistance = 36;
			this.camera.control.enablePan = false;
		});
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 2;
		this.add(this.ambient);
		// this.helperLight = new HelperLitght("Ambiente fuera", this.ambient);
	}
	//

	renderAnimations() {
		// this.tooltipsMenu.renderChangePositions();
	}
}
